module.exports = __webpack_public_path__ + "static/media/29FUNOV1.dd2d8d22.jpg";